import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import IconBase from "../icons/IconBase";
var LogoSquare = function(_param) {
    var _width = _param.width, width = _width === void 0 ? 48 : _width, _height = _param.height, height = _height === void 0 ? 48 : _height, props = _object_without_properties(_param, [
        "width",
        "height"
    ]);
    return /*#__PURE__*/ _jsxs(IconBase, _object_spread_props(_object_spread({
        $styles: {
            width: width,
            height: height
        },
        viewBox: "0 0 48 48"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                width: "48",
                height: "48",
                rx: "10.4",
                fill: "#FFD02F"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M33.3415 6H28.0732L32.4634 13.7143L22.8049 6H17.5366L22.3659 15.4286L12.2683 6H7L12.2683 18L7 42H12.2683L22.3659 16.2857L17.5366 42H22.8049L32.4634 14.5714L28.0732 42H33.3415L43 12L33.3415 6Z",
                fill: "#050038"
            })
        ]
    }));
};
export default LogoSquare;
